import { Button } from "@/shared/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES } from "@/core/router/routes";

interface GuestInviteContentProps {
  invitationMessage: string;
  toEmail: string;
}

export default function GuestInviteContent({
  invitationMessage,
  toEmail,
}: GuestInviteContentProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginClick = () => {
    // Get current path with all query parameters
    const returnTo = `${location.pathname}${location.search}`;

    // Navigate to login page with returnTo parameter
    const loginPath = `/${ROUTES.Auth.Root}/${
      ROUTES.Auth.SignIn
    }?returnTo=${encodeURIComponent(returnTo)}`;
    navigate(loginPath);
  };

  return (
    <div className="auth-page-container flex items-center flex-col w-[395px]">
      {/* Invitation message */}
      <h3 className="text-[24px] leading-[32px] tracking-[-0.015em] font-[700] text-[#09090B] mb-[12px] text-center">
        {invitationMessage}
      </h3>

      {/* "To accept the invitation please login as" text */}
      <div className="text-[16px] font-400 leading-[24px] mb-[4px] text-center text-muted-foreground">
        To accept to invitation please login as
      </div>

      {/* Email address */}
      <div className="text-[16px] font-[700] text-black mb-[24px] text-center">
        {toEmail}
      </div>

      {/* Log in button */}
      <div className="w-full flex flex-col items-center justify-center">
        <Button variant="success" onClick={handleLoginClick}>
          Log in
        </Button>
      </div>
    </div>
  );
}
